<script setup>
import { ref } from 'vue'
import { useAuthStore } from '@stores/auth'
import { useRouter } from 'vue-router'
import TransitionFade from '@components/global/transitions/TransitionFade.vue'

const router = useRouter()
const auth = useAuthStore()
const isOpen = ref(false)

const toggle = () => {
	isOpen.value = !isOpen.value
}
const close = () => {
	isOpen.value = false
}
</script>

<template>
	<div class="relative">
		<button @click="toggle" class="flex h-10 w-10 items-center justify-center rounded-full bg-logi-grey-500 text-logi-blue-500 transition-colors duration-200 hover:bg-logi-grey-400"><i class="fa-regular fa-user" /></button>

		<transition name="fade">
			<div v-if="isOpen" class="absolute right-0 top-14 z-50 w-56 bg-logi-grey-500 shadow-lg lg:w-72" v-click-outside="close">
				<div class="p-4 lg:px-6 lg:py-5" v-if="auth.user?.first_name">
					<div class="font-semibold uppercase text-white">Hi {{ auth.user?.first_name }}</div>
				</div>

				<div class="border-t border-logi-grey-400" v-if="auth.user?.first_name"></div>

				<div class="py-2">
					<router-link :to="{ name: 'account.events' }" @click="close">
						<div class="w-full px-4 py-3 text-left text-sm font-semibold uppercase text-logi-blue-500 transition-colors hover:bg-logi-grey-400 lg:px-6">My Events</div>
					</router-link>

					<a href="/admin" v-if="auth.user?.is_admin">
						<div class="w-full px-4 py-3 text-left text-sm font-semibold uppercase text-logi-blue-500 transition-colors hover:bg-logi-grey-400 lg:px-6">Admin Panel</div>
					</a>

					<button @click="auth.logout" class="w-full px-4 py-3 text-left text-sm font-semibold uppercase text-logi-blue-500 transition-colors hover:bg-logi-grey-400 lg:px-6">
						<i class="fa-solid fa-arrow-right-from-bracket"></i>
						Log Out
					</button>
				</div>
			</div>
		</transition>
	</div>
</template>
